import { useMemo, useState } from 'react'
import { useInterval } from 'react-use'

export function useVatPercentage (): number {
  const [now, setNow] = useState(() => new Date())
  useInterval(() => {
    setNow(new Date())
  }, 1000 * 60 * 60)
  return useMemo(() => {
    // Javascript's Date months are 0-based
    if (now.getFullYear() > 2025 || now.getMonth() >= 11) {
      return 21
    } else {
      return 9
    }
  }, [now])
}
